module.exports = __webpack_public_path__ + "img/ke.3754638.svg";